export default "__VITE_ASSET__B4_cBrkR__";